import DataUrlHelper from '../../../../helpers/data-url.helper';
import legsAsWheel from '../../../../../assets/illustrations/legs-as-wheel-clouds.svg';

function LinkToParticipationOverviewPuff({ participationId, className }: { participationId: number; className?: string }) {
  return (
    <div className={className}>
      <div className="row g-0">
        <div className="col-sm-6 d-flex justify-content-center bg-blue-100 p-3">
          <img alt="" src={DataUrlHelper.encode(legsAsWheel)}></img>
        </div>

        <div className="col-sm-6 bg-gray d-flex align-items-center">
          <div className="text p-3">
            På <a href={`/klass/${participationId}`}>klassens sida</a> kan elever och föräldrar följa utmaningen.
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkToParticipationOverviewPuff;
